// pdf-viewer-wrapper.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfWrapperComponent } from './pdf-wrapper.component';

@NgModule({
    declarations: [PdfWrapperComponent],
    imports: [
        CommonModule,
        PdfViewerModule
    ],
    exports: [PdfWrapperComponent]
})
export class PdfViewerWrapperModule { }
